import { Controller } from "@hotwired/stimulus"
import { Chart, ArcElement, Tooltip, Legend, DoughnutController, BarController, BarElement, CategoryScale, LinearScale } from 'chart.js'

Chart.register(ArcElement, Tooltip, Legend, DoughnutController, BarController, BarElement, CategoryScale, LinearScale)

export default class extends Controller {
  static targets = ["donut1", "donut2", "bar"]

  connect() {
    if (this.hasDonut1Target) this.renderDonut1()
    if (this.hasDonut2Target) this.renderDonut2()
    if (this.hasBarTarget) this.renderBar()
  }

  disconnect() {
    if (this.donut1Chart) this.donut1Chart.destroy()
    if (this.donut2Chart) this.donut2Chart.destroy()
    if (this.barChart) this.barChart.destroy()
  }

  renderDonut1() {
    this.donut1Chart = new Chart(this.donut1Target, {
      type: 'doughnut',
      data: {
        labels: ['Donations', 'Events', 'Memberships', 'Volunteering'],
        datasets: [{
          data: [45, 25, 18, 12],
          backgroundColor: ['#EE6840', '#157F83', '#95999F', '#CACCCF'],
          borderWidth: 0
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        cutout: '60%',
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              padding: 16,
              usePointStyle: true,
              pointStyle: 'circle',
              font: { size: 11, family: "'Roboto', 'Open Sans', sans-serif" },
              color: '#616770'
            }
          }
        }
      }
    })
  }

  renderDonut2() {
    this.donut2Chart = new Chart(this.donut2Target, {
      type: 'doughnut',
      data: {
        labels: ['Program', 'Administrative', 'Fundraising'],
        datasets: [{
          data: [65, 20, 15],
          backgroundColor: ['#157F83', '#EE6840', '#E9EAEB'],
          borderWidth: 0
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        cutout: '60%',
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              padding: 16,
              usePointStyle: true,
              pointStyle: 'circle',
              font: { size: 11, family: "'Roboto', 'Open Sans', sans-serif" },
              color: '#616770'
            }
          }
        }
      }
    })
  }

  renderBar() {
    this.barChart = new Chart(this.barTarget, {
      type: 'bar',
      data: {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
        datasets: [
          {
            label: 'Revenue',
            data: [12000, 19000, 15000, 22000, 18000, 25000],
            backgroundColor: '#EE6840',
            borderRadius: 3,
            barPercentage: 0.6,
            categoryPercentage: 0.7
          },
          {
            label: 'Expenses',
            data: [8000, 11000, 9000, 14000, 12000, 16000],
            backgroundColor: '#157F83',
            borderRadius: 3,
            barPercentage: 0.6,
            categoryPercentage: 0.7
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          x: {
            grid: { display: false },
            ticks: {
              font: { size: 11, family: "'Roboto', 'Open Sans', sans-serif" },
              color: '#95999F'
            }
          },
          y: {
            grid: { color: '#E9EAEB' },
            ticks: {
              font: { size: 11, family: "'Roboto', 'Open Sans', sans-serif" },
              color: '#95999F',
              callback: function(value) {
                return '$' + (value / 1000) + 'k'
              }
            }
          }
        },
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              padding: 16,
              usePointStyle: true,
              pointStyle: 'circle',
              font: { size: 11, family: "'Roboto', 'Open Sans', sans-serif" },
              color: '#616770'
            }
          }
        }
      }
    })
  }
}
